import * as actionTypes from "../actions/actionTypes";

import {
  getAllTeams,
  updateTeam,
  createTeam,
  deleteTeam,
  clearAllTeams,
  saveTName,
  saveSort,
  clearSearch,
} from "../utility/allTeamFunctions";

const initialState = {
  teams: [],
  searchedName: "",
  sortingOrder: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_TEAMS:
      return getAllTeams(state, action.allTeam);

    case actionTypes.UPDATE_TEAM:
      return updateTeam(state, action.team);

    case actionTypes.CREATE_TEAM:
      return createTeam(state, action.team);

    case actionTypes.DELETE_TEAM:
      return deleteTeam(state, action.team);

    case actionTypes.CLEAR_ALL_TEAMS:
      return clearAllTeams(state);

    case actionTypes.SAVE_SEARCH_TNAME:
      return saveTName(state, action.name);

    case actionTypes.SAVE_SORT:
      return saveSort(state, action.sort);

    case actionTypes.CLEAR_SEARCH_TNAME:
      return clearSearch(state);

    default:
      return state;
  }
};

export default reducer;
